import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { Box, Chip, Divider, IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import Addevent from './Addevent'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { makeDeleteRequest } from 'utils/api'
import MaSimulationResult from '../MaSimulationResult'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

// LAP-733 (GE022) — server-side category id → i18n key
const CATEGORY_I18N_KEYS = {
  Cash: 'cashLabel',
  'Fonds en devise': 'fundInCurrency',
  Fondsendevise: 'fundInCurrency',
  Alternatifs: 'alternative',
  Immobilier: 'realEstate',
  Actions: 'shares',
  Matériel: 'material',
  Materiel: 'material',
  Material: 'material',
  Dettes: 'debts',
}

const DEFAULT_SIMULATION_RATES = {
  Cash: 1,
  'Fonds en devise': 3,
  Fondsendevise: 3,
  Alternatifs: 5,
  Immobilier: 3,
  Actions: 6,
  Matériel: -5,
  Materiel: -5,
  Material: -5,
  Dettes: 2,
}

export default function ParmetreSimulationForm({ updateReports, setParmSimulationOpen }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [simulationRate, setSimulationRate] = useState([])
  const [customsimulationRate, setCustomSimulationRate] = useState({
    VersmentAnnuel: 0,
    TauxCash: 0,
    TauxFonds: 0,
    TauxAlternatifs: 0,
    TauxImmobilier: 0,
    TauxActions: 0,
    TauxMaterial: 0,
  })

  const [open, setOpen] = useState(true)
  const [openEvent, setOpenEvent] = useState(false)
  const [openSimulation, setOpenSimulation] = useState(false)
  const [customEvents, setCustomEvents] = useState([])

  const { handleSubmit, reset } = useForm({})

  useEffect(() => {
    getSimulationRate()
    getCustomSimulation()
    getCustomEventSimulation()
    handleProfil('Équilibré')
  }, [])

  // const handleClickOpen = () => {
  //   setOpen(true)
  // }

  const handleClose = () => {
    setOpen(false)
    reset()
    setParmSimulationOpen(false)
  }

  const onSubmitg = async (data) => {
    const payload = {
      simulationRate: simulationRate,
    }

    const response = await makePostRequest(urls.UpdateSimulationRate, payload, {}, true)
    if (response.status === 200) {
      updateReports()
      handleClose()
    }
  }
  const getSimulationRate = async () => {
    const url = urls.getSimulationRate
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const allRatesAreEmpty = data.every((item) => Number(item.Rate || 0) === 0)
      const nextRates = allRatesAreEmpty
        ? data.map((item) => ({
            ...item,
            Rate: DEFAULT_SIMULATION_RATES[item.Category] ?? 0,
          }))
        : data
      setSimulationRate(nextRates)
    }
  }
  const getCustomSimulation = async () => {
    const url = urls.getCustomSimulation
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      // setCustomSimulationRate(data[0])
    }
  }
  const getCustomEventSimulation = async () => {
    const url = urls.CustomEventSimulation
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setCustomEvents(data.results)
    }
  }

  const handleProfil = (val) => {
    let update = { ...customsimulationRate, Profil: val }
    if (val === 'Personnalisé') {
      update = {
        ...update,
        TauxCash: 0,
        TauxFonds: 0,
        TauxAlternatifs: 0,
        TauxImmobilier: 0,
        TauxActions: 0,
        TauxMaterial: 0,
      }
    }
    if (val === 'Sans risque') {
      update = {
        ...update,
        TauxCash: 20,
        TauxFonds: 80,
        TauxAlternatifs: 0,
        TauxImmobilier: 0,
        TauxActions: 0,
        TauxMaterial: 0,
      }
    }
    if (val === 'Prudent') {
      update = {
        ...update,
        TauxCash: 10,
        TauxFonds: 60,
        TauxAlternatifs: 0,
        TauxImmobilier: 20,
        TauxActions: 10,
        TauxMaterial: 0,
      }
    }
    if (val === 'Équilibré') {
      update = {
        ...update,
        TauxCash: 10,
        TauxFonds: 30,
        TauxAlternatifs: 0,
        TauxImmobilier: 35,
        TauxActions: 25,
        TauxMaterial: 0,
      }
    }
    if (val === 'Dynamique') {
      update = {
        ...update,
        TauxCash: 5,
        TauxFonds: 15,
        TauxAlternatifs: 10,
        TauxImmobilier: 30,
        TauxActions: 40,
        TauxMaterial: 0,
      }
    }
    if (val === 'Offensif') {
      update = {
        ...update,
        TauxCash: 5,
        TauxFonds: 0,
        TauxAlternatifs: 15,
        TauxImmobilier: 25,
        TauxActions: 55,
        TauxMaterial: 0,
      }
    }
    setCustomSimulationRate(update)
  }
  const handleDelEvent = async (id) => {
    const { data, status } = await makeDeleteRequest(
      urls.CustomEventSimulation + id + '/',
      {},
      true,
    )
    if (status === 204) {
      getCustomEventSimulation()
    }
  }
  const inputSx = {
    width: 76,
    minWidth: 76,
    marginTop: 5,
    textAlign: 'right',
    border: '1px solid rgba(20, 104, 183, 0.22)',
    borderRadius: 8,
    padding: '8px 10px',
    fontWeight: 800,
    color: '#10233f',
    background: '#ffffff',
  }
  const rowSx = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    marginTop: 9,
  }
  const allocationTotal =
    Number(customsimulationRate.TauxCash || 0) +
    Number(customsimulationRate.TauxFonds || 0) +
    Number(customsimulationRate.TauxAlternatifs || 0) +
    Number(customsimulationRate.TauxImmobilier || 0) +
    Number(customsimulationRate.TauxActions || 0) +
    Number(customsimulationRate.TauxMaterial || 0)

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        className="no-drag"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            bgcolor: '#f7fbff',
            boxShadow: '0 24px 70px rgba(0,0,0,0.35)',
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 12, right: 12, zIndex: 2 }}
          aria-label="fingerprint"
          color="secondary"
        >
          <CloseIcon sx={{ color: '#10233f' }} />
        </IconButton>
        <DialogTitle sx={{ color: '#10233f !important', bgcolor: '#ffffff', px: 3, py: 2.5 }}>
          <Typography sx={{ color: '#1468b7', fontSize: 12, fontWeight: 850, textTransform: 'uppercase' }}>
            {t('monPatrimoine.simulationEyebrow')}
          </Typography>
          <Typography sx={{ color: '#10233f', fontSize: 28, fontWeight: 900, lineHeight: 1.1 }}>
            {t('monPatrimoine.simulationTitle')}
          </Typography>
          <Typography sx={{ color: '#5a6f86', fontSize: 14.5, mt: 0.8 }}>
            {t('monPatrimoine.simulationSubtitle')}
          </Typography>
        </DialogTitle>

        <form onSubmit={handleSubmit(onSubmitg)} name="fform">
          <DialogContent sx={{ maxHeight: '70vh', overflowY: 'auto', px: 3, py: 2.5 }}>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
              <Box sx={{ p: 2, bgcolor: '#ffffff', borderRadius: 2, border: '1px solid rgba(20, 104, 183, 0.12)' }}>
                <Typography sx={{ color: '#10233f', fontWeight: 900, fontSize: 18 }}>
                  {t('monPatrimoine.evolutionRatesByAssetClass')}
                </Typography>
                <Typography sx={{ color: '#5a6f86', fontSize: 13.5, mt: 0.4 }}>
                  {t('monPatrimoine.evolutionRatesNote')}
                </Typography>

                <Box mt={1.5}>
                  {simulationRate.map((e) => (
                    <div key={e.id} style={rowSx}>
                      <label style={{ color: '#294765', fontWeight: 750 }}>{CATEGORY_I18N_KEYS[e.Category] ? t('monPatrimoine.' + CATEGORY_I18N_KEYS[e.Category]) : e.Category}</label>
                      <span>
                      <input
                        type="number"
                        min={-100}
                        max={100}
                        value={parseInt(e.Rate).toFixed(0)}
                        onChange={(el) => {
                          let filter = simulationRate.filter((v) => v.id !== e.id)
                          let update = { ...e, Rate: el.target.value }
                          setSimulationRate(
                            [...filter, update].sort((a, b) => (a.id > b.id ? 1 : -1)),
                          )
                        }}
                        style={inputSx}
                      />
                      {' % '}
                      </span>
                    </div>
                  ))}
                </Box>
              </Box>
              <Box sx={{ p: 2, bgcolor: '#ffffff', borderRadius: 2, border: '1px solid rgba(20, 104, 183, 0.12)' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
                  <Box>
                    <Typography sx={{ color: '#10233f', fontWeight: 900, fontSize: 18 }}>
                      {t('monPatrimoine.contributionAndDistribution')}
                    </Typography>
                    <Typography sx={{ color: '#5a6f86', fontSize: 13.5, mt: 0.4 }}>
                      {t('monPatrimoine.contributionAndDistributionNote')}
                    </Typography>
                  </Box>
                  <Chip
                    label={`${allocationTotal}%`}
                    sx={{
                      bgcolor: allocationTotal === 100 ? '#edf7ef' : '#fff3df',
                      color: allocationTotal === 100 ? '#227142' : '#9b5d00',
                      fontWeight: 850,
                    }}
                  />
                </Stack>
                <Box mt={1.5}>
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.annualContributionAmount')}</label>
                    <span>
                    <input
                      type="number"
                      value={customsimulationRate.VersmentAnnuel}
                      onChange={(el) => {
                        setCustomSimulationRate({
                          ...customsimulationRate,
                          VersmentAnnuel: el.target.value,
                        })
                      }}
                      style={{ ...inputSx, width: 140, minWidth: 140 }}
                    />
                    {'€'}
                    </span>
                  </div>
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.byProfile')}</label>
                    <select
                      style={{
                        ...inputSx,
                        width: '160px',
                        minWidth: '160px',
                        textAlign: 'left',
                      }}
                      onChange={(el) => {
                        handleProfil(el.target.value)
                      }}
                      value={customsimulationRate?.Profil}
                    >
                      {/* LAP-733 (GE022) — value attr preserves data ID; display is translated */}
                      <option value="Personnalisé">{t('monPatrimoine.profileCustom')}</option>
                      <option value="Sans risque">{t('monPatrimoine.profileNoRisk')}</option>
                      <option value="Prudent">{t('monPatrimoine.profilePrudent')}</option>
                      <option value="Équilibré">{t('monPatrimoine.profileBalanced')}</option>
                      <option value="Dynamique">{t('monPatrimoine.profileDynamic')}</option>
                      <option value="Offensif">{t('monPatrimoine.profileOffensive')}</option>
                    </select>
                  </div>
                  <Divider sx={{ my: 1.2 }} />
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.cashLabel')}</label>
                    <span>
                    <input
                      type="number"
                      min={-100}
                      max={100}
                      value={customsimulationRate.TauxCash}
                      onChange={(el) => {
                        setCustomSimulationRate({
                          ...customsimulationRate,
                          TauxCash: el.target.value,
                        })
                      }}
                      style={inputSx}
                    />
                    {' % '}
                    </span>
                  </div>
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.fundInCurrency')}</label>
                    <span>
                    <input
                      type="number"
                      min={-100}
                      max={100}
                      value={customsimulationRate.TauxFonds}
                      onChange={(el) => {
                        setCustomSimulationRate({
                          ...customsimulationRate,
                          TauxFonds: el.target.value,
                        })
                      }}
                      style={inputSx}
                    />
                    {' % '}
                    </span>
                  </div>
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.alternative')}</label>
                    <span>
                    <input
                      type="number"
                      min={-100}
                      max={100}
                      value={customsimulationRate.TauxAlternatifs}
                      onChange={(el) => {
                        setCustomSimulationRate({
                          ...customsimulationRate,
                          TauxAlternatifs: el.target.value,
                        })
                      }}
                      style={inputSx}
                    />
                    {' % '}
                    </span>
                  </div>
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.realEstate')}</label>
                    <span>
                    <input
                      type="number"
                      min={-100}
                      max={100}
                      value={customsimulationRate.TauxImmobilier}
                      onChange={(el) => {
                        setCustomSimulationRate({
                          ...customsimulationRate,
                          TauxImmobilier: el.target.value,
                        })
                      }}
                      style={inputSx}
                    />
                    {' % '}
                    </span>
                  </div>
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.shares')}</label>
                    <span>
                    <input
                      type="number"
                      min={-100}
                      max={100}
                      value={customsimulationRate.TauxActions}
                      onChange={(el) => {
                        setCustomSimulationRate({
                          ...customsimulationRate,
                          TauxActions: el.target.value,
                        })
                      }}
                      style={inputSx}
                    />
                    {' % '}
                    </span>
                  </div>
                  <div style={rowSx}>
                    <label style={{ color: '#294765', fontWeight: 750 }}>{t('monPatrimoine.material')}</label>
                    <span>
                    <input
                      type="number"
                      min={-100}
                      max={100}
                      value={customsimulationRate.TauxMaterial}
                      onChange={(el) => {
                        setCustomSimulationRate({
                          ...customsimulationRate,
                          TauxMaterial: el.target.value,
                        })
                      }}
                      style={inputSx}
                    />
                    {' % '}
                    </span>
                  </div>
                </Box>
              </Box>
            </Box>
            <Box mt={2} sx={{ p: 2, bgcolor: '#ffffff', borderRadius: 2, border: '1px solid rgba(20, 104, 183, 0.12)' }}>
              <Typography sx={{ color: '#10233f', fontWeight: 900, fontSize: 18 }}>
                {t('monPatrimoine.simulationEvents')}
              </Typography>
              <Typography sx={{ color: '#5a6f86', fontSize: 13.5, mt: 0.4 }}>
                {t('monPatrimoine.simulationEventsNote')}
              </Typography>
              <Box mt={2}>
                {customEvents.map((el) => (
                  <Box
                    key={el.id}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      border: '1px solid rgba(20, 104, 183, 0.12)',
                      borderRadius: '12px',
                      fontWeight: '700',
                      mt: 1,
                      px: 1.5,
                      py: 0.8,
                      color: '#294765',
                      bgcolor: '#f7fbff',
                    }}
                  >
                    <Box></Box>
                    <Box>{el.Nom}</Box>
                    <Box>/</Box>
                    <Box>{t('monPatrimoine.eventYearLabel', { year: el.AnneeDebut.slice(-4) })}</Box>
                    <Box>/</Box>
                    <Box>{t('monPatrimoine.eventPerYear', { amount: parseInt(el.ValeurInitial).toFixed(0) })}</Box>
                    <Box></Box>
                    <Box></Box>
                    <Box>
                      <IconButton onClick={() => handleDelEvent(el.id)} color="secondary">
                        <DeleteForeverIcon sx={{ color: '#fd5f5f' }} />
                      </IconButton>
                    </Box>
                  </Box>
                ))}
              </Box>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 2 }}>
                <IconButton onClick={() => setOpenEvent(true)}>
                  <AddCircleIcon
                    sx={{ fontSize: '54px', color: '#1468b7', ':hover': { cursor: 'pointer' } }}
                  />
                </IconButton>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              px: 3,
              py: 2,
              bgcolor: '#ffffff',
              borderTop: '1px solid rgba(20, 104, 183, 0.1)',
              justifyContent: 'space-between',
              gap: 1,
              flexWrap: 'wrap',
            }}
          >
            <Button
              type="button"
              sx={{ textTransform: 'none', fontWeight: 800 }}
              onClick={() => handleProfil('Équilibré')}
            >
              {t('monPatrimoine.resetToBalanced')}
            </Button>
            <Stack direction="row" gap={1} flexWrap="wrap" justifyContent="flex-end">
              <Button
                type="submit"
                name="new1"
                variant="outlined"
                sx={{ borderRadius: 999, textTransform: 'none', fontWeight: 850 }}
              >
                {t('monPatrimoine.saveBaseRates')}
              </Button>
              <Button
                type="button"
                onClick={() => {
                  setOpenSimulation(true)
                }}
                variant="contained"
                sx={{ borderRadius: 999, textTransform: 'none', fontWeight: 850 }}
              >
                {t('monPatrimoine.showSimulationResult')}
              </Button>
              <Button type="button" onClick={handleClose} sx={{ borderRadius: 999, textTransform: 'none', fontWeight: 850 }}>
                {t('monPatrimoine.close')}
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
      {openEvent && (
        <Addevent setOpenEvent={setOpenEvent} updateSimulation={getCustomEventSimulation} />
      )}
      {openSimulation && (
        <MaSimulationResult
          setOpenSimulation={setOpenSimulation}
          customsimulationRate={customsimulationRate}
          simulationRate={simulationRate}
        />
      )}
    </>
  )
}
